module.exports = __webpack_public_path__ + "packs/media/images/Pricing-40c320278c39bd4035bff6332a9d3f17.jpg";